export const liVariants = {
    initial: {
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
    }, animate: (i) => ({
        opacity: 1,
        transform: "translate3d(0, 0%, 0)",
        transition: {
            duration: 1,
            delay: 0.015 * i[1],
            ease: [0.16, 1, 0.3, 1]
        }
    }), exit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
        transition: {
            duration: 1,
            delay: 0.01 * i[1],
            ease: [0.65, 0, 0.35, 1]
        }
    }), defaultExit: (i) => ({
        transform: "translate3d(0, 100%, 0)",
        opacity: 0,
        transition: {
            duration: 0.65,
            delay: 0.01 * i[1],
            ease: [0.65, 0, 0.35, 1]
        }
    })
}
